import React, {useState} from 'react'
import '../addStock.css'

const ExpiryDateInput = (props: any) => {
  const { row, column, table , getValue}= props.props;
  const [expiryDate, setExpiryDate] = useState(getValue() !== ''?getValue() :null)
 
  const today: string = new Date().toISOString().split('T')[0];

  const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExpiryDate(e.target.value)
  }

  const onBlur = ()=>{
    table.options.meta?.updateData(row.index,column.id,expiryDate);
  }

  return (
    <div className='input-group'>
      <input
        className='table-input'
        type='date'
        value={expiryDate}
        placeholder='Pack Size'
        min={today} 
        onChange={updateValue}
        onBlur={()=>onBlur()}
      />
    </div>
  )
}

export default ExpiryDateInput
